import * as AuthVerify from '../lib/common';
const compareReducer = (state = 0, action) => {
    switch (action.type) {
        case 'PRODUCT':
            return state+1;
        default:
            return state
    }
}
export default compareReducer
